import { useMedia } from 'react-use';

export const useIsPortraitMode = () => useMedia('(orientation: portrait)');
